"use client";

import { c as _c } from "react/compiler-runtime";
import { memo } from "react";
import Image from "next/image";
import Link from "@/components/ui/Link";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getTimeAgo, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  title?: FieldConfig;
  timeAgo?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  /** Mark as LCP image - preloads for faster rendering */
  priority?: boolean;
  imageMetadata?: ImageMetadata;
  templatetype?: FieldConfig;
};
const VerticalMediumImageNewsBuilderComponent = t0 => {
  const $ = _c(45);
  const {
    title: t1,
    timeAgo: t2,
    imageSrc: t3,
    slug,
    priority: t4,
    imageMetadata,
    templatetype: t5
  } = t0;
  let t6;
  if ($[0] !== t1) {
    t6 = t1 === undefined ? {
      hidden: false,
      value: "\u0BB2\u0BCB\u0B95\u0BC7\u0BB7\u0BCD \u0B95\u0BA9\u0B95\u0BB0\u0BBE\u0B9C\u0BCD \u0B87\u0BAF\u0B95\u0BCD\u0B95\u0BC1\u0BB5\u0BA4\u0BC1 \u0BB0\u0B9C\u0BBF\u0BA9\u0BBF\u0BAF\u0BBF\u0BA9\u0BCD \u0B95\u0B9F\u0BC8\u0B9A\u0BBF \u0BAA\u0B9F\u0BAE\u0BBE? \u0BA8\u0B9F\u0BBF\u0B95\u0BB0\u0BCD \u0BB0\u0B9C\u0BBF\u0BA9\u0BBF\u0B95\u0BBE\u0BA8\u0BCD\u0BA4\u0BCD '\u0B9C\u0BC6\u0BAF\u0BBF\u0BB2\u0BB0\u0BCD' \u0BAA\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD \u0BA8\u0B9F\u0BBF\u0BA4\u0BCD\u0BA4\u0BC1 \u0BAE\u0BC1\u0B9F\u0BBF\u0BA4\u0BCD\u0BA4\u0BC1\u0BB3\u0BCD\u0BB3\u0BBE\u0BB0\u0BCD.",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const title = t6;
  let t7;
  if ($[2] !== t2) {
    t7 = t2 === undefined ? {
      hidden: false,
      value: "21 min ago",
      customClass: ""
    } : t2;
    $[2] = t2;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const timeAgo = t7;
  let t8;
  if ($[4] !== t3) {
    t8 = t3 === undefined ? {
      hidden: false,
      value: FALLBACK_IMAGE,
      customClass: ""
    } : t3;
    $[4] = t3;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const imageSrc = t8;
  const priority = t4 === undefined ? false : t4;
  let t9;
  if ($[6] !== t5) {
    t9 = t5 === undefined ? {
      hidden: false,
      value: "",
      customClass: ""
    } : t5;
    $[6] = t5;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  const templatetype = t9;
  const titleValue = title?.value || "";
  const t10 = timeAgo?.value;
  let t11;
  if ($[8] !== t10) {
    t11 = getTimeAgo(t10);
    $[8] = t10;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  const timeAgoValue = t11;
  let t12;
  if ($[10] !== imageSrc?.value) {
    t12 = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;
    $[10] = imageSrc?.value;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  const imageSrcValue = t12;
  const isLiveBlog = templatetype?.value === "live-blog" || templatetype?.value === "true";
  let t13;
  if ($[12] !== imageMetadata || $[13] !== imageSrc?.customClass || $[14] !== imageSrc?.hidden || $[15] !== imageSrcValue || $[16] !== priority || $[17] !== titleValue) {
    t13 = !imageSrc?.hidden && <div className={`relative w-full aspect-[16/9] overflow-hidden ${imageSrc?.customClass || ""}`} style={{
      contain: "layout"
    }}><Image src={imageSrcValue} alt={titleValue} fill={true} priority={priority} className="object-cover" style={getFocusPointStyle(imageMetadata)} loading={priority ? "eager" : "lazy"} fetchPriority={priority ? "high" : "auto"} sizes="(max-width: 768px) 100vw, (max-width: 1200px) 33vw, 300px" placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /></div>;
    $[12] = imageMetadata;
    $[13] = imageSrc?.customClass;
    $[14] = imageSrc?.hidden;
    $[15] = imageSrcValue;
    $[16] = priority;
    $[17] = titleValue;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== isLiveBlog || $[20] !== title?.customClass || $[21] !== title?.hidden || $[22] !== titleValue) {
    t14 = !title?.hidden && <h3 className={`text-14-tamil-700 text-1B1B1B leading-[1.4] h-auto ${title?.customClass || ""}`}>{isLiveBlog && <span className="inline-flex items-center gap-1.5 mr-2 align-middle"><span className="relative inline-flex h-4 w-4 items-center justify-center"><span className="absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-40 animate-[wave_1.5s_ease-out_infinite]" /><span className="absolute inline-flex h-3 w-3 rounded-full bg-red-500 opacity-60 animate-[wave_1.5s_ease-out_0.3s_infinite]" /><span className="relative inline-flex rounded-full h-2 w-2 bg-red-600" /></span></span>}{titleValue}</h3>;
    $[19] = isLiveBlog;
    $[20] = title?.customClass;
    $[21] = title?.hidden;
    $[22] = titleValue;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== timeAgo?.customClass || $[25] !== timeAgo?.hidden || $[26] !== timeAgoValue) {
    t15 = !timeAgo?.hidden && <span className={`text-12-tamil-500 text-1B1B1B ${timeAgo?.customClass || ""}`}>{timeAgoValue}</span>;
    $[24] = timeAgo?.customClass;
    $[25] = timeAgo?.hidden;
    $[26] = timeAgoValue;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  const t16 = slug ? `/${slug}` : undefined;
  let t17;
  if ($[28] !== imageSrcValue || $[29] !== slug || $[30] !== t16 || $[31] !== titleValue) {
    t17 = <div className="flex gap-3"><MessageIcon id="message-icon-1" slug={slug} category={BOOKMARK_CATEGORIES.NEWS} title={titleValue} thumbnailUrl={imageSrcValue} articleUrl={t16} /></div>;
    $[28] = imageSrcValue;
    $[29] = slug;
    $[30] = t16;
    $[31] = titleValue;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t15 || $[34] !== t17) {
    t18 = <div className="flex items-center justify-between gap-2">{t15}{t17}</div>;
    $[33] = t15;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t14 || $[37] !== t18) {
    t19 = <div className="flex flex-col gap-3">{t14}{t18}</div>;
    $[36] = t14;
    $[37] = t18;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t13 || $[40] !== t19) {
    t20 = <div className="flex flex-col overflow-hidden p-4 gap-4 bg-F8F8F8">{t13}{t19}</div>;
    $[39] = t13;
    $[40] = t19;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  const content = t20;
  if (slug) {
    const t21 = `/${slug}`;
    let t22;
    if ($[42] !== content || $[43] !== t21) {
      t22 = <Link href={t21} className="block  transition-colors cursor-pointer">{content}</Link>;
      $[42] = content;
      $[43] = t21;
      $[44] = t22;
    } else {
      t22 = $[44];
    }
    return t22;
  }
  return content;
};

// Memoize to prevent unnecessary re-renders
export const VerticalMediumImageNewsBuilder = memo(VerticalMediumImageNewsBuilderComponent);